import {Box, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {ErrorState, SentinelLoading} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {LoadingSkeleton} from '../../components/LoadingSkeleton';
import {FilterDrawer} from '../../components/FilterDrawer';
import {ExamsListEmptyState} from '../../components/ExamsListEmptyState';
import {ExamCardsGrid} from '../../components/ExamsCardsGrid';
import {ExamDrawer} from '../../components/ExamDrawer';

import {ExamsContainer} from './styles';
import {useExamRequests} from 'presentation/modules/examResults/hooks/useExamRequests';
import {ExamsRequestsFlowEnum} from 'presentation/modules/examResults/hooks/useExamRequests/types';

const {resultError} = translations['pt-br'].privateFlow.examResults;
const {resultFound, resultsFound} = translations['pt-br'].commons;

export function WaitingExamResults() {
	const {
		loadingItemsList,
		itemsListHasError,
		refresh,
		itemsListIsEmpty,
		items,
		onSentinelVisible,
		isLoadingMore,
		totalItems,
		handleClearFilters,
		hasFilterActive,
	} = useExamRequests(ExamsRequestsFlowEnum.WAITING);

	if (loadingItemsList && !isLoadingMore) {
		return (
			<ExamsContainer>
				<LoadingSkeleton />
			</ExamsContainer>
		);
	}
	if (itemsListHasError) {
		return (
			<ErrorState
				title={resultError.title}
				description={resultError.description}
				handleRefresh={refresh}
				containerDataTagId={
					ExamResultsTaggingEnum.VISUALIZOU_ERROR_STATE_AGUARDANDO_LIBERACAO
				}
			/>
		);
	}

	if (itemsListIsEmpty && !hasFilterActive) {
		return (
			<ExamsContainer>
				<ExamsListEmptyState clearFilter={handleClearFilters} isWaitingResult />
			</ExamsContainer>
		);
	}

	return (
		<ExamsContainer>
			<Stack gap={2}>
				<Stack direction={'row'} justifyContent="space-between" alignItems="center">
					{itemsListIsEmpty ? null : (
						<Typography color={'text.secondary'} textTransform={'lowercase'}>
							<b>{totalItems}</b> {totalItems === 1 ? resultFound : resultsFound}
						</Typography>
					)}

					<Box ml="auto">
						<FilterDrawer isWaitingResult />
					</Box>
				</Stack>
				{itemsListIsEmpty ? (
					<ExamsListEmptyState clearFilter={handleClearFilters} isWaitingResult />
				) : (
					<Fragment>
						<ExamCardsGrid list={items} isWaitingResult />
						<ExamDrawer isWaitingResult />

						<SentinelLoading
							onVisible={onSentinelVisible}
							isLoading={loadingItemsList}
						/>
					</Fragment>
				)}
			</Stack>
		</ExamsContainer>
	);
}
